import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
import { FLIGHT_TYPE_OPTIONS, MULTI_DESTINATION, ROUND_TRIP } from "./constants.js";
const parseDate = (dateString)=>{
    if (!dateString || 8 !== dateString.length) return;
    const year = parseInt(dateString.substring(0, 4), 10);
    const month = parseInt(dateString.substring(4, 6), 10) - 1;
    const day = parseInt(dateString.substring(6, 8), 10);
    return new Date(year, month, day);
};
const getSelectedDates = (flightIndex, flights, watchFlightType, defaultFlightType)=>{
    const flight = flights[flightIndex];
    if (flightIndex > 0) return parseDate(flight?.startDate);
    const isRoundTripFlight = (watchFlightType || defaultFlightType) === ROUND_TRIP;
    if (isRoundTripFlight) return {
        from: parseDate(flight?.startDate),
        to: parseDate(flight?.endDate)
    };
    return parseDate(flight?.startDate);
};
const getMultiDestinationSelectedDate = (flightIndex, flights)=>{
    const flight = flights[flightIndex];
    return parseDate(flight?.startDate);
};
const onCalendarChange = (dates, setDefaultMonth, setValue, flightIndex = 0)=>{
    if (!setValue) return;
    if (dates instanceof Date) {
        const formattedDate = format(dates, 'yyyyMMdd');
        setValue(`flights.${flightIndex}.startDate`, formattedDate, {
            shouldDirty: true
        });
        setDefaultMonth(dates);
    } else if (dates && 'from' in dates && 'to' in dates) {
        if (dates.from) {
            const startDate = format(dates.from, 'yyyyMMdd');
            setValue(`flights.${flightIndex}.startDate`, startDate, {
                shouldDirty: true
            });
            setDefaultMonth(dates.from);
            setValue(`flights.${flightIndex}.endDate`, '', {
                shouldDirty: true
            });
        }
        if (dates.to) {
            const endDate = format(dates.to, 'yyyyMMdd');
            setValue(`flights.${flightIndex}.endDate`, endDate, {
                shouldDirty: true
            });
        }
    }
};
function getAllowedFlightTypes(flightTypes) {
    if (!flightTypes?.length) return FLIGHT_TYPE_OPTIONS.map((option)=>option.value);
    return flightTypes;
}
function resolveInitialFlightType(requested, allowed) {
    if (requested && allowed.includes(requested)) return requested;
    return allowed[0] ?? ROUND_TRIP;
}
function normalizeInitialFlightValues(values, allowed) {
    const flightType = resolveInitialFlightType(values.flightType, allowed);
    const shouldDropExtraLegs = flightType !== MULTI_DESTINATION && (values.flights?.length ?? 0) > 1;
    return {
        ...values,
        flightType,
        ...shouldDropExtraLegs ? {
            flights: values.flights?.slice(0, 1)
        } : {}
    };
}
const createRadioOptions = (flightTypes)=>{
    const allowed = new Set(getAllowedFlightTypes(flightTypes));
    return FLIGHT_TYPE_OPTIONS.filter((option)=>allowed.has(option.value)).map((option)=>({
            value: option.value,
            labelNode: option.label,
            name: 'flightType',
            size: '16'
        }));
};
const addFlightOnClick = (setValue, watchFlights)=>{
    const existingFlights = watchFlights || [];
    const lastFlight = existingFlights[existingFlights.length - 1];
    const newFlight = {
        startLocation: lastFlight?.endLocation || {},
        endLocation: {},
        startDate: '',
        endDate: ''
    };
    setValue('flights', [
        ...existingFlights,
        newFlight
    ]);
};
function getMultiDestDefaultMonth(prevFlightStartDate, currentFlightStartDate) {
    const currentDate = new Date();
    if (currentFlightStartDate) return parse(currentFlightStartDate, 'yyyyMMdd', currentDate);
    if (prevFlightStartDate) return parse(prevFlightStartDate, 'yyyyMMdd', currentDate);
    return currentDate;
}
function getMultiDestDisabledDates(prevFlightStartDate) {
    if (prevFlightStartDate) return parse(prevFlightStartDate, 'yyyyMMdd', new Date());
    return new Date();
}
export { addFlightOnClick, createRadioOptions, getAllowedFlightTypes, getMultiDestDefaultMonth, getMultiDestDisabledDates, getMultiDestinationSelectedDate, getSelectedDates, normalizeInitialFlightValues, onCalendarChange, parseDate, resolveInitialFlightType };
